import { twMerge } from "tailwind-merge";

export function BellOff({ className }: { className?: string }) {
  return (
    <svg
      className={twMerge("size-10 bg-bg-primary", className)}
      fill="none"
      viewBox="0 0 39 39"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        height="37"
        rx="18.5"
        stroke="#DC6803"
        strokeOpacity="0.1"
        strokeWidth="2"
        width="37"
        x="1"
        y="1"
      />
      <rect
        height="27"
        rx="13.5"
        stroke="#DC6803"
        strokeOpacity="0.3"
        strokeWidth="2"
        width="27"
        x="6"
        y="6"
      />
      <path
        d="M16.6942 12.0284C17.5163 11.4711 18.4925 11.167 19.5 11.167C20.8261 11.167 22.0979 11.6938 23.0355 12.6315C23.9732 13.5691 24.5 14.8409 24.5 16.167C24.5 17.9176 24.7252 19.293 25.0403 20.3607M14.7156 14.7147C14.5739 15.1814 14.5 15.6704 14.5 16.167C14.5 18.7421 13.8504 20.5053 13.1247 21.6715C12.5126 22.6552 12.2065 23.1471 12.2178 23.2843C12.2302 23.4362 12.2624 23.4942 12.3848 23.585C12.4954 23.667 12.9938 23.667 13.9907 23.667H23.6667M17.2951 27.0003C17.8828 27.519 18.6546 27.8337 19.5 27.8337C20.3454 27.8337 21.1172 27.519 21.7049 27.0003M27 27.0003L12 12.0003"
        stroke="#DC6803"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.66667"
      />
    </svg>
  );
}
